import HttpResponse from 'es/core/net/HttpResponse';
import HttpClient from 'es/core/net/http';

/**
 * Logs the user out and returns the signin URL
 */
export async function logout(): Promise<string> {
    const response: HttpResponse<string> = await HttpClient.useInternalApi.asAuthorised().post('security/logout', null);

    if (!response.isSuccess || !response.data) throw new Error('Failed to log out');

    return response.data;
}

export default logout;
